import { forwardRef, type Ref, type SVGProps } from "react";
const IconBusFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <rect width={2} height={4} x={1} y={12} fill="currentColor" rx={1} />
    <rect width={2} height={4} x={29} y={12} fill="currentColor" rx={1} />
    <path
      fill="currentColor"
      d="M24 2H8a4 4 0 0 0-4 4v18a1.9 1.9 0 0 0 1.8 2h20.4a1.9 1.9 0 0 0 1.8-1.9V6a4 4 0 0 0-4-4M10 22a2 2 0 1 1 2-2 2 2 0 0 1-2 2m12 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2m4-8a2.1 2.1 0 0 1-2.2 2H8.2A2.1 2.1 0 0 1 6 14V8a2.1 2.1 0 0 1 2.2-2h15.6A2.1 2.1 0 0 1 26 8zm-7 12v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2zM7 26v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconBusFilledSVG);
ForwardRef.displayName = "IconBusFilled";
export { ForwardRef as IconBusFilled };
